// import React from 'react';
// import {Checkroom, SportsMotorsports } from '@mui/icons-material';

// const AccesoriesFilter = () => {
//   return (
//     <>
//      <h2 className="text-lg font-semibold mb-4">Filter</h2>
//     <div className="w-full bg-white shadow-lg rounded-lg mt-2 border">
//       <h2 className="text-md font-semibold mb-4 p-3">Categories</h2>
//       <div className="grid grid-cols-2 gap-4 p-3">
//         <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//           <SportsMotorsports className="mb-2 text-5xl" />
//           Helmet
//         </button>
//         <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//           <Checkroom className="mb-2 text-5xl" />
//           Jacket
//         </button>
//         <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//           <SportsMotorsports className="mb-2 text-5xl" />
//           Riding Gear
//         </button>
//         <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//           <SportsMotorsports className="mb-2 text-5xl" />
//           Helmet
//         </button>
//       </div>
//     </div>
//     </>
//   );
// };

// export default AccesoriesFilter;

import React, { useState } from 'react';
import { Checkroom, SportsMotorsports } from '@mui/icons-material';

const AccesoriesFilter = () => {
  // Dummy JSON Data
  const categories = [
    { id: 1, label: 'Helmet', icon: <SportsMotorsports className="mb-2 text-5xl" /> },
    { id: 2, label: 'Jacket', icon: <Checkroom className="mb-2 text-5xl" /> },
    { id: 3, label: 'Riding Gear', icon: <SportsMotorsports className="mb-2 text-5xl" /> },
    { id: 4, label: 'Helmet 2', icon: <SportsMotorsports className="mb-2 text-5xl" /> },
  ];

  // State for form data
  const [formData, setFormData] = useState({
    selectedCategory: '', // Store the selected category here
  });

  // Handle category selection
  const handleCategorySelect = (label) => {
    setFormData((prevData) => ({
      ...prevData,
      selectedCategory: label, // Update the selectedCategory in formData
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Use FormData to simulate form submission
    const data = new FormData();
    data.append('selectedCategory', formData.selectedCategory);

    // Log the form data to simulate submission
    console.log('Form Data:', Object.fromEntries(data));
  };

  return (
    <>
      <h2 className="text-lg font-semibold mb-4">Filter</h2>
      <form
        className="w-full bg-white shadow-lg rounded-lg mt-2 border"
        onSubmit={handleSubmit}
      >
        <h2 className="text-md font-semibold mb-4 p-3">Categories</h2>
        <div className="grid grid-cols-2 gap-4 p-3">
          {categories.map((category) => (
            <button
              type="button"
              key={category.id}
              className={`flex flex-col items-center justify-center p-3 border rounded-md text-center ${
                formData.selectedCategory === category.label ? 'border-[#FF9630]' : 'border-gray-300'
              }`}
              onClick={() => handleCategorySelect(category.label)}
            >
              {category.icon}
              {category.label}
            </button>
          ))}
        </div>
        <div className="p-3">
          <button
            type="submit"
            className="w-full bg-[#FF9630] text-white py-2 px-4 rounded-md"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default AccesoriesFilter;
